import { PetId } from '../../../Constants/Pets';
import { FTUXType } from '../../../Player/PlayerProperty/Progress/FTUXType';
import { ArrayHelper } from '../../../Utility/ArrayHelper';
import { Immutable } from '../../../Utility/Types';
import { IPlayerState } from '../IPlayerState';
import { PlayerStateHelper } from '../PlayerStateHelper';
import { PlayerTask } from '../PlayerTasks';
import { IPetsState } from './IPetsState';
import { getHighestLevelCompleted } from '../../Player/PlayerLevelHelper';
import { WorldDataHelper } from '../../../Utility/WorldDataHelper';
import { FTUXStateHelper } from 'State/Game/FTUX/FTUXStateHelper';
import { IGameState } from 'State/Game/IGameState';

export namespace PetsStateHelper {
    export const unlockPet = (oldState: IPetsState, ...petIds: PetId[]): IPetsState => {
        let state = { ...oldState };

        for (let i = 0; i < petIds.length; i++) {
            state = {
                ...state,
                unlockedPets: ArrayHelper.addIfNeeded(state.unlockedPets, petIds[i]),
            };
        }

        return state;
    };

    export const setActivePet = (state: IPetsState, petId: PetId): IPetsState => {
        if (!PetsStateHelper.isPetUnlocked(state, petId)) return state;
        return { ...state, activePet: petId };
    };

    export const isPetUnlocked = (state: Immutable<IPetsState>, petId: PetId): boolean => {
        return state.unlockedPets.includes(petId);
    };

    export const isAnyPetUnlocked = (state: Immutable<IPetsState>): boolean => {
        return state.unlockedPets.length > 0;
    };

    export const queuePetFTUXIfNeeded = (oldState: IPlayerState): IPlayerState => {
        let state = { ...oldState };
        if (
            state.petsState.unlockedPets.length > 0 &&
            !FTUXStateHelper.isFtuxCompleted(state, FTUXType.PET_UNLOCK) &&
            oldState.tasks.find(task => task.task === PlayerTask.PET_FTUX) === undefined
        ) {
            const lastAddedPet = state.petsState.unlockedPets[state.petsState.unlockedPets.length - 1];

            // Set last added pet as active pet
            state = updatePlayerState(state, setActivePet(state.petsState, lastAddedPet));

            const currentLevel = getHighestLevelCompleted(state);
            state = setPetLevel(state, currentLevel > WorldDataHelper.maxLevel() ? currentLevel : currentLevel + 1);

            // Queue FTUX task
            state = PlayerStateHelper.addStateTaskDatas(state, [
                {
                    task: PlayerTask.PET_FTUX,
                    petLevel: state.petLevel,

                    petId: state.petsState.activePet,
                },
            ]);
        }
        return state;
    };

    export const updatePlayerState = (state: IPlayerState, patch: Partial<IPetsState>): IPlayerState => {
        return {
            ...state,
            petsState: {
                ...state.petsState,
                ...patch,
            },
        };
    };

    export const updateGameState = (state: IGameState, patch: Partial<IPetsState>): IGameState => {
        return {
            ...state,
            playerState: updatePlayerState(state.playerState, patch),
        };
    };

    export const setIsPetInDaily = (state: IGameState, petInDaily: boolean): IGameState => {
        state = {
            ...state,
            playerState: {
                ...state.playerState,
                petsState: {
                    ...state.playerState.petsState,
                    petInDailyLogin: petInDaily,
                },
            },
        };
        return state;
    };

    export const setPetLevel = (state: IPlayerState, petLevel: number): IPlayerState => {
        return {
            ...state,
            petLevel,
        };
    };
}
